module.exports = __webpack_public_path__ + "static/media/redOnion.e57f8c61.PNG";